import {useMemo} from "react";
import {ConfirmOrderController, useConfirmOrderContext} from "../../../../../../reducer/moduleReducer/confirmOrder";
import {isEmptyObj} from "../../../../../../utils";
import {ModalAddressForm} from "../../../../../../publicComponent/ModalAddressForm";
import ActionSheet from "../../../../../../publicComponent/h5/ActionSheet";
import Modal from "../../../../../../publicComponent/Modal";
import Dialog from "../../../../../../publicComponent/Dialog";
import {useTranslation} from "react-i18next";

function AddressCard({ data, selectAddress, currentAddress, type }) {
  const { formVisibleHandle, removeAddress } = ConfirmOrderController();
  const { t } = useTranslation();
  
  const isDefault = useMemo(() => {
    if (!currentAddress) return false;
    return currentAddress.id === data.id;
  }, [currentAddress]);
  
  const remove = (id) => {
    Dialog.confirm({
      content: t('确定要删除吗？'),
      onOk: (onClose) => {
        removeAddress(id);
        onClose();
      }
    });
  };
  
  return (
    <>
      {
        type === 'add'
          ? <div onClick={() => formVisibleHandle()}
                 className="flex rounded-[10px] border cursor-pointer border-[#ddd] bg-white items-center h-[186px]">
            <div className="text-center flex-1">
              <i className="iconfont icon-plus"></i>
              <p>{t('使用新地址')}</p>
            </div>
          </div>
          : <div onClick={() => selectAddress(data)}
                 className={'relative rounded-[10px] border cursor-pointer ' +
                 `${isDefault ? 'border-[#FFC75A] bg-[#FFFCF5]' : 'border-[#ddd] bg-white'} `}>
            <div className={'rounded-[8px] border pt-[25px] py-[20px] px-[20px] ' +
            `${isDefault ? 'border-[#FFC75A]' : 'border-[transparent]'}`}>
              {
                isDefault &&
                <i style={{ lineHeight: '12px' }}
                   className="absolute right-[15px] top-[20px] iconfont icon-yes text-[20px] text-[#FFC75A]"></i>
              }
              <p className="mb-[10px] text-[16px] font-bold">{data.linkor}</p>
              <div className="mb-[5px] flex">
                <i className="iconfont icon-mobile"></i>
                <p className="ml-[5px]">{data.mobileNo}</p>
              </div>
              <div className="mb-[5px] flex min-h-[48px]">
                <i className="iconfont icon-location"></i>
                <p className="ml-[5px] pb-[5px] line-clamp-2 text-[14px]">{data.areaName} {data.address}</p>
              </div>
              <div className="flex pr-[50px]">
                <div className="flex items-center flex-1">
                  <div className="cursor-pointer"
                       onClick={(e) => {
                         e.stopPropagation();
                         remove(data.id);
                       }
                       }>
                    <i className="relative top-[2px] iconfont icon-remove mr-[5px] text-[18px] text-[#666]"></i>
                    <p className="inline-block text-[14px] text-[#666]">{t('删除')}</p>
                  </div>
                </div>
                <div className="flex items-center flex-1">
                  <div className="cursor-pointer"
                       onClick={(e) => {
                         e.stopPropagation();
                         formVisibleHandle(data);
                       }}>
                    <i className="relative top-[2px] iconfont icon-edit mr-[5px] text-[18px] text-[#666]"></i>
                    <p className="inline-block text-[14px] text-[#666]">{t('修改')}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        
      }
    </>
  );
}

export default function ShippingAddressList() {
  const { selectAddress, getAddressList, closeFormVisible, addressListModalVisibleHandle } = ConfirmOrderController();
  const { state } = useConfirmOrderContext();
  const { address, addressList, formVisible, addressQuery, addressListModalVisible } = state;
  const { t } = useTranslation();
  
  return (
    <>
      <div className={`grid gap-6 pr-[50px] mb-[20px] mdmax:hidden grid-cols-${addressList.length <= 2 ? 3 : 4}`}>
        {
          addressList.map((item, i) => (
            <AddressCard selectAddress={selectAddress}
                         currentAddress={address}
                         key={i}
                         data={item}/>
          ))
        }
        <AddressCard type={'add'}/>
      </div>
      <div className="mx-[3%] py-[15px] md:hidden">
        {
          !isEmptyObj(address)
            ? <div className="flex"
                   onClick={() => addressListModalVisibleHandle(true)}>
              <i className="iconfont icon-location pr-[10px]"></i>
              <div className="flex-1">
                <p className="mb-[5px]">
                  <span className="font-bold text-[15px] pr-[10px]">{address.linkor}</span>
                  <span className="text-[15px]">{address.mobileNo}</span>
                </p>
                <p>{address.areaName}{address.address}</p>
              </div>
              <div className="w-[45px] text-center">
                <i className="iconfont icon-right text-[18px] text-[#999]"></i>
              </div>
            </div>
            : <div className="py-[5px] text-center text-[14px]"
                   onClick={() => addressListModalVisibleHandle(true)}>
              <span>{t('请选择收货地址')}</span>
              <i className="iconfont icon-right ml-[15px]"></i>
            </div>
        }
      </div>
      
      <Modal title={t('请选择收货地址')}
             visible={addressListModalVisible}
             onClose={addressListModalVisibleHandle}>
        <div>
          {
            addressList.map((data, i) => (
              <div className="py-[10px] border-b px-[5px] mx-[10px]"
                   onClick={() => selectAddress(data)}
                   key={i}>
                <div className="flex justify-between items-center px-[10px]">
                  <div className="mr-[8px]">
                    <h6 className={`font-bold mb-[5px] mdmax:mb-[8px] text-[16px] ${data.id === address.id ? 'text-[#FFC75A]' : ''}`}>
                      {data.linkor}
                    </h6>
                    <p className="mb-[10px] mdmax:mb-[5px] mdmax:text-[13px]">
                      <i className="iconfont icon-mobile mr-[8px] mdmax:hidden"></i>
                      {data.mobileNo}
                    </p>
                    <p className="mdmax:text-[13px]">
                      <i className="iconfont icon-location mr-[8px] mdmax:hidden"></i>
                      {data.areaName}{data.address}
                    </p>
                  </div>
                  <div className="mb-[5px]">
                    {
                      data.id === address.id
                        ? <i className="cursor-pointer iconfont icon-yes text-[18px] text-[#FFC75A]"></i>
                        : <i className="cursor-pointer iconfont icon-right text-[18px] text-[#999]"></i>
                    }
                  </div>
                </div>
              </div>
            ))
          }
        </div>
      </Modal>
      
      <ModalAddressForm visible={formVisible}
                        formQuery={addressQuery}
                        submitSuccess={() => {
                          getAddressList();
                          closeFormVisible();
                        }}
                        onClose={closeFormVisible}/>
    </>
  );
}
